import SignIn from '../pages/sign-in/SignIn';
import SignUp from '../pages/sign-up/SignUp';
import ForgotPassword from '../pages/forgot-password/ForgotPassword';
import Verification from '../pages/verification/Verification';
import ChangePassword from '../pages/change-password/ChangePassword';
import PhonePick from '../pages/create-agent/phone-pick/PhonePick';
import CallActivity from '../pages/call-activity/CallActivity';
import ProfileInfo from '../pages/profile/ProfileInfo';
import ProfilePassword from '../pages/profile/ProfilePassword';
import SubscriptionPlan from '../pages/create-agent/subscription-plan/SubscriptionPlan';
import UpgradePlan from '../pages/create-agent/subscription-plan/UpgradePlan';
import Subscription from '../pages/subscription/Subscription';
import PageNotFound from '../pages/page-not-found/PageNotFound';
import MyAgent from '../pages/my-agent/MyAgent';
import TrainingGuide from '../pages/training-guide/TrainingGuide';
import MobileChangeInfo from 'components/page-components/profile/MobileChangeInfo';
import ApiKey from '../pages/profile/ApiKey';
import Greetings from '../pages/greetings/Greetings';
import VoicePicker from '../pages/create-agent/voice-picker/VoicePicker';
import AutomationTemplate from '../pages/automation-template/AutomationTemplate';
import ActionsPage from '../pages/actions/ActionsPage';
import KnowledgeBase from 'components/page-components/agents/KnowledgeBase';
import FullTextPage from 'components/page-components/agents/FullTextPage';
import Loading from '../pages/create-agent/loading/Loading';
import TimeZone from '../pages/create-agent/time-zone/TimeZone';
import Recordings from '../pages/recordings';
import TrialConfirmation from '../pages/create-agent/trial-confirmation/TrialConfirmation';
import SignInByUserId from 'pages/sign-in/SignInByUserId';
import SignInByToken from 'pages/sign-in/SignInByToken';
import GoogleCalendarOauth from '../pages/oauth/GoogleCalendarOauth';
import CompanyDetails from 'pages/CompanyDetails';
import AgentDemoPage from 'pages/agent-demo-page';

import ViewRecording from '../pages/view-recording/ViewRecording';


export const PATHS = {
    SIGN_IN: '/sign-in',
    SIGN_IN_BY_TOKEN: '/sign-in-with-token',
    SIGN_UP: '/sign-up',
    FORGOT_PASSWORD: '/forgot-password',
    VERIFICATION: '/verification',
    CHANGE_PASSWORD: '/change-password',
    BUSINESS_INFO: '/business-info',
    ADDITIONAL_BUSINESS_INFO: '/additional-business-info',
    PHONE_PICK: '/phone-pick',
    SUBSCRIPTION_PLAN: '/subscription-plan',
    UPGRADE_PLAN: '/upgrade-plan',
    MY_AGENT: '/my-agent',
    CALL_ACTIVITY: '/call-activity/:id?',
    PROFILE_INFO: '/profile/information',
    PROFILE_PASSWORD: '/profile/password',
    SUBSCRIPTION: '/subscription',
    PAGE_NOT_FOUND: '/page-not-found',
    TRAINING_GUIDE: '/training-guide/:id?',
    CHANGE_INFO: '/change-information',
    ADD_MINUTES: '/add-minutes',
    API_KEY: '/profile/api-key',
    GREETINGS: '/greetings/:id?',
    VOICE_PICKER: '/voice-picker',
    TRIAL_CONFIRMATION: '/trial-confirmation',
    AUTOMATION_TEMPLATE: '/integrations',
    ACTIONS: '/actions/:id?',
    KNOWLEDGE_BASE: '/knowledge-base/:id?',
    FULL_TEXT: '/full-text/:agentId/:knowledgeId',
    LOADING: '/loading',
    TIME_ZONE: '/time-zone',
    TELL_US_MORE: '/tell-us-more',
    RECORDINGS: '/recordings/:id?',
    AGENT_CONFIGURATION: 'agent-configuration',
    
    AGENT_CONFIGURATION_TRAINING: 'training',
    AGENT_CONFIGURATION_KNOWLEDGE: 'knowledge',
    AGENT_CONFIGURATION_GREETING: 'greeting',
    AGENT_CONFIGURATION_CHAT: 'chat',
    AGENT_CONFIGURATION_TRANSFERS: 'transfers',
    AGENT_CONFIGURATION_MORE_SETTINGS: 'more-settings',
    USER_ADMIN_SIGN_IN: 'sign-in-admin',
    OAUTH_GOOGLE_CALENDAR_PAGE: '/oauth/google-calendar',
    COLLECT_COMPANY_DETAILS: '/company-details',
    AGENT_DEMO_PAGE: '/agent-demo',

    VIEW_RECORDING: '/view-recording/:id?',
};

export const stepperPages = [
    PATHS.TELL_US_MORE,
    PATHS.BUSINESS_INFO,
    PATHS.CREATE_YOUR_GREETING,
    PATHS.ADDITIONAL_BUSINESS_INFO,
    PATHS.LOADING,
    PATHS.TEST_CHAT,
    PATHS.VOICE_PICKER,
    PATHS.SUBSCRIPTION_PLAN,
    PATHS.TRIAL_CONFIRMATION,
    PATHS.PHONE_PICK,
    PATHS.COLLECT_COMPANY_DETAILS,
    PATHS.AGENT_DEMO_PAGE
    // PATHS.TIME_ZONE,
];

export const privatRoutes = [
    {
        path: PATHS.VOICE_PICKER,
        component: VoicePicker,
    },
    {
        path: PATHS.PHONE_PICK,
        component: PhonePick,
    },
    {
        path: PATHS.SUBSCRIPTION_PLAN,
        component: SubscriptionPlan,
    },
    {
        path: PATHS.UPGRADE_PLAN,
        component: UpgradePlan,
    },
    {
        path: PATHS.TRIAL_CONFIRMATION,
        component: TrialConfirmation,
    },
    {
        path: PATHS.MY_AGENT,
        component: MyAgent,
    },
    {
        path: PATHS.CALL_ACTIVITY,
        component: CallActivity,
    },
    {
        path: PATHS.AUTOMATION_TEMPLATE,
        component: AutomationTemplate,
    },
    {
        path: PATHS.PROFILE_INFO,
        component: ProfileInfo,
    },
    {
        path: PATHS.SUBSCRIPTION,
        component: Subscription,
    },
    {
        path: PATHS.PROFILE_PASSWORD,
        component: ProfilePassword,
    },
    {
        path: PATHS.TRAINING_GUIDE,
        component: TrainingGuide,
    },
    {
        path: PATHS.CHANGE_INFO,
        component: MobileChangeInfo,
    },
    { path: PATHS.API_KEY, component: ApiKey },
    { path: PATHS.GREETINGS, component: Greetings },
    {
        path: PATHS.ACTIONS,
        component: ActionsPage,
    },
    {
        path: PATHS.KNOWLEDGE_BASE,
        component: KnowledgeBase,
    },
    {
        path: PATHS.FULL_TEXT,
        component: FullTextPage,
    },
    {
        path: PATHS.LOADING,
        component: Loading,
    },
    {
        path: PATHS.TIME_ZONE,
        component: TimeZone,
    },
    {
        path: PATHS.OAUTH_GOOGLE_CALENDAR_PAGE,
        component: GoogleCalendarOauth,
    },
    {
        path: PATHS.COLLECT_COMPANY_DETAILS,
        component: CompanyDetails,
    },
    {
        path: PATHS.AGENT_DEMO_PAGE,
        component: AgentDemoPage,
    },
];

export const beforeTrialPages = [
    {
        path: PATHS.MY_AGENT,
        component: MyAgent,
    },
    {
        path: PATHS.PROFILE_INFO,
        component: ProfileInfo,
    },
    {
        path: PATHS.TRAINING_GUIDE,
        component: TrainingGuide,
    },
    { path: PATHS.GREETINGS, component: Greetings },
];


export const publicRoutes = [
    { path: PATHS.SIGN_IN, component: SignIn },
    { path: PATHS.SIGN_IN_BY_TOKEN, component: SignInByToken },
    { path: PATHS.USER_ADMIN_SIGN_IN, component: SignInByUserId },
    {
        path: PATHS.SIGN_UP,
        component: SignUp,
    },
    {
        path: PATHS.FORGOT_PASSWORD,
        component: ForgotPassword,
    },
    {
        path: PATHS.VERIFICATION,
        component: Verification,
    },
    {
        path: PATHS.CHANGE_PASSWORD,
        component: ChangePassword,
    },
    {
        path: PATHS.PAGE_NOT_FOUND,
        component: PageNotFound,
    },
    { path: PATHS.RECORDINGS, component: Recordings },

    { path: PATHS.VIEW_RECORDING, component: ViewRecording },
];
